import PortfolioPage from '../components/portfolio-page';

export default PortfolioPage;
